import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import { SnackbarProvider } from 'notistack';
import i18n from './modules/i18n';
import App from './App';
import * as serviceWorker from './serviceWorker';
// notistack

ReactDOM.render(
  <I18nextProvider i18n={i18n}>
    <SnackbarProvider>
      <App />
    </SnackbarProvider>
  </I18nextProvider>,
  document.getElementById('root')
);

serviceWorker.register();
